export default {
    isOpen: 'is-open',
    isActive: 'is-active',
    isVisible: 'is-visible',
    isHidden: 'is-hidden',
    isCurrent: 'is-current',
    isSelected: 'is-selected',
    isLoading: 'is-loading',
    isInitialised: 'is-initialised',
    isPlaying: 'is-playing',
    isNavOpen: 'is-nav-open',
    isSiteSearchOpen: 'is-site-search-open',
    hasToolTip: 'has-tooltip',
    hasDropdown: 'has-dropdown',
};